import { render, staticRenderFns } from "./NotesList.vue?vue&type=template&id=4ad19010&scoped=true"
import script from "./NotesList.vue?vue&type=script&lang=js"
export * from "./NotesList.vue?vue&type=script&lang=js"
import style0 from "./NotesList.vue?vue&type=style&index=0&id=4ad19010&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad19010",
  null
  
)

export default component.exports